import React from 'react';
import AdminAwardReportList from "./AdminAwardReportList";
import ApiAwardReport from "../../code/api/ApiAwardReport";
import AwardReportInfo from "../../code/models/AwardReportInfo";
import AdminAwardReportLoadReports from "./AdminAwardReportLoadReports";
import '../../css/adminawardreports.css';
import AdminAwardReportEmail from "./AdminAwardReportEmail";

interface IAdminAwardReportsForm { }

export default function AdminAwardReportsForm({ }: IAdminAwardReportsForm) {
    const [currentInfo, setCurrentInfo] = React.useState<AwardReportInfo | null>(null);
    const [currentPage, setCurrentPage] = React.useState<string>("reports");
    const pageImport: string = "import";
    const pageLoad: string = "load";
    const pageReports: string = "reports";

    React.useEffect(() => {
        loadHistory();
    }, []);

    var loading: boolean;

    function loadHistory() {
        if (loading) return;
        loading = true;

        ApiAwardReport.getAwardReportInfo().then((data) => {
            if (!!data) {
                setCurrentInfo(data);
                var stat = (data.importRequest?.status || "").toLowerCase();
                if (!!stat && stat !== "complete" && stat !== "error" && stat !== "deleted") {
                    setTimeout(loadHistory, 5000);
                }
            }
        }).finally(() => { loading = false; });
    }

    function getTabClassName(tabInfo: string) {
        switch (currentPage + tabInfo) {
            case currentPage + currentPage: return "nav-link active";
            default: return "nav-link";
        }
    }

    return (
        <React.Fragment>
            <div className="awardreport-tabinfo">
                <div className="awardreport-div">
                    <span className="awardreport-title">Email Award Reports</span>
                    {!!currentInfo && <span className="awardreport-label">Bid Period: {currentInfo?.bidPeriod.month}</span>}
                </div>
                <div className="awardreport-form">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <a className={getTabClassName(pageReports)} href="#" onClick={() => setCurrentPage(pageReports)}>Award Reports</a>
                        </li>
                        <li className="nav-item">
                            <a className={getTabClassName(pageLoad)} href="#" onClick={() => setCurrentPage(pageLoad)}>Load Award Reports</a>
                        </li>
                        <li className="nav-item">
                            <a className={getTabClassName(pageImport)} href="#" onClick={() => setCurrentPage(pageImport)}>Email Award Reports</a>
                        </li>
                    </ul>
                </div>
            </div>
            {currentPage === pageReports && <AdminAwardReportList awardReports={currentInfo?.awardReports || []} />}
            {currentPage === pageLoad && !!currentInfo && <AdminAwardReportLoadReports awardReportInfo={currentInfo}
                onRefreshRequest={loadHistory} />}
            {currentPage === pageImport && !!currentInfo && <AdminAwardReportEmail awardReportInfo={currentInfo}
                onRefreshRequest={loadHistory} />}
        </React.Fragment >
    )
}

